import {atom} from "recoil";
import {persistAtomEffect} from "../effects/persistAtom";
export const walletCardChangeSubsState = atom({
  key: 'walletCardChangeSubsState',
  default: null,
  effects: []
});
